// @flow
import * as React from "react";
import { withLocalize } from "react-localize-redux";
import './LanguageToggle.css'

const LanguageToggle = ({ languages, activeLanguage, setActiveLanguage }) => (
  <div className={'LanguageSelector'}>
    {languages.map(lang => (
        <button key={lang.code} className= {'LanguageButton'.concat((activeLanguage.code === lang.code) ? '--disabled' : '') } onClick={() => setActiveLanguage(lang.code)}>
          {lang.name}
        </button>
    ))}
  </div>
);

export default withLocalize(LanguageToggle);
